var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 11h-6V5h-2v6H5v2h6v6h2v-6h6v-2z"}));
}

Plus.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Plus;

Plus.default = Plus;
